import { AttachmentScanStatus } from '../models/Attachment';
import { emailApiClient } from './emailApiClient';

export interface EmailContentAttachment {
  fileId: string;
  fileName: string;
  scanStatus: AttachmentScanStatus;
}

export interface EmailContentTransfer {
  fromQueue: string;
  byAgent: string;
}

export interface EmailContent {
  from?: string | null;
  to?: string[];
  cc?: string[];
  subject?: string | null;
  deliveredTo?: string | null;
  bodyHtml?: string | null;
  attachments?: EmailContentAttachment[];
  transferInfo?: EmailContentTransfer | null;
}

export const fetchEmailContent = async (contactId: string): Promise<EmailContent> => {
  const params = new URLSearchParams({ contactId });
  const response = await emailApiClient(`/content?${params.toString()}`, {
    method: 'GET'
  });

  if (!response.ok) throw new Error(`API responded with status ${response.status}`);

  const json = (await response.json()) as { meta: { version: string }; data: EmailContent };
  return json.data;
};
